module.exports = "<div class=\"progressbar\" [@progressbar]=\"state\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/progressbar/progressbar.component.html
// module id = LWnX
// module chunks = 6